import { Box, Skeleton } from "@chakra-ui/react";
import GameBannerAd from "../Advertisement/GameBannerAd";
import { motion } from "framer-motion";

function LoadingSkeletons() {
  const elements = [
    <Box h={{ base: "300px", md: "480px" }} />,
    <GameBannerAd />,
    <Box h={{ base: "300px", md: "480px" }} />,
    <Box h={{ base: "300px", md: "480px" }} mt='40px' />,
    <Box h={{ base: "300px", md: "480px" }} />,
    <Box h={{ base: "300px", md: "480px" }} mb='40px' />,
    <Box h={{ base: "300px", md: "480px" }} />,
  ];
  return (
    <Box
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {elements.map((el, i) => (
        <Skeleton key={i}>{el}</Skeleton>
      ))}
    </Box>
  );
}

export default LoadingSkeletons;
